module.exports = __webpack_public_path__ + "static/media/home.f39ed77f.png";